import { Button, DropdownMenu, DropdownMenuItem } from '@stone-payments/jade'

import { isLucyChatReady, openLucyChat } from '../lib/lucy-chat'

export function LucyChatTriggerButton() {
  if (!isLucyChatReady()) return null

  return (
    <DropdownMenu
      allowedPlacements={['bottom-end']}
      trigger={
        <Button variant="neutral-subtle" size="medium" icon="circle-help">
          Ajuda
        </Button>
      }
    >
      <DropdownMenuItem
        icon="circle-help"
        label="Central de ajuda"
        description="Encontre a resposta para a sua dúvida."
        // eslint-disable-next-line webview-safety/no-restricted-browser-apis
        onClick={() => window.open('https://ajuda.stone.com.br/', '_blank')}
      />
      <DropdownMenuItem
        icon="chat"
        label="Atendimento via chat"
        description="Disponível 24 horas por dia."
        onClick={openLucyChat}
      />
    </DropdownMenu>
  )
}
